module.exports = __webpack_public_path__ + "assets/27ec5aa7ab1b5217bf300390682b64f0.jpg";